import { useTheme } from "@emotion/react";
import {
  Box,
  Button,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { PencilSquare, TrashFill } from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import DeleteDialog from "../DeleteDialog/DeleteDialog";
import toast from "react-hot-toast";
import styles from "./paymentmethod.module.css";
import NewPaymentMethod from "./NewPaymentMethod/NewPaymentMethod";
import EditPaymentMethod from "./EditPaymentMethod/EditPaymentMethod";
import { arEG } from "@mui/material/locale";

const columns = [
  { id: "name", label: "طريقة الدفع", minWidth: 170 },
  { id: "type", label: "النوع", minWidth: 170 },
  { id: "allowDiscount", label: "تفعيل الخصومات", minWidth: 100 },
  { id: "showAmount", label: "ظهور قيمة المبلغ", minWidth: 100 },
  { id: "actions", label: "", minWidth: 100 },
];

function PaymentMethodTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openDialog, setOpenDialog] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const theme = useTheme();
  const role = useSelector((state) => state.auth.role.roleName);

  const [data, setData] = useState([]);
  const fetchData = useCallback(async () => {
    // setLoading(true);
    try {
      const types = await axios.get(
        `${process.env.REACT_APP_API_URL}/paymentmethod/`,
        {
          withCredentials: true,
        }
      );
      setData(types.data);

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleCloseNewForm = () => setOpenAdd(false);
  const handleCloseEditForm = () => setOpenEdit(false);
  const handleCloseDialog = () => setOpenDialog(false);

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setOpenEdit(true);
  };
  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setOpenDialog(true);
  };
  const handleAllowDiscount = async (row) => {
    let value =  !row.allowDiscount;
    let editedRow = {
      ...row,
      allowDiscount: value,
    };
    if(row.allowDiscount === false){
      if (row.showAmount === false){
        editedRow.showAmount = true
      }
    }
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/paymentmethod/${row.id}`,
        editedRow,
        {
          withCredentials: true,
        }
      );

      if (res) {
        fetchData();
        if (editedRow.allowDiscount) {
          toast.success("تم تفعيل الخصومات على طريقة الدفع.");
        } else {
          toast.success("تم إيقاف الخصومات على طريقة الدفع.");
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };

  const handleShowAmount = async (row) => {
    let value = !row.showAmount;
    if (row.allowDiscount === true) {
      if (row.showAmount === true) {
        toast.error("لا يمكن إخفاء المبلغ مع إحتمالية وجود خصم.");
        return;
      }
      value = true;
    }
    const editedRow = {
      ...row,
      showAmount: value,
    };

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/paymentmethod/${row.id}`,
        editedRow,
        {
          withCredentials: true,
        }
      );

      if (res) {
        fetchData();
        if (editedRow.showAmount) {
          toast.success("تم السماح بظهور المبلغ.");
        } else {
          toast.success("تم إيقاف السماح بظهور المبلغ.");
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };
  const handleDelete = async () => {
    if (deleteId) {
      try {
        const res = await axios.delete(
          `${process.env.REACT_APP_API_URL}/paymentmethod/${deleteId}`,
          {
            withCredentials: true,
          }
        );
        if (res) {
          toast.success("تم حذف طريقة الدفع بنجاح!");
          setData((prevData) =>
            prevData.filter((item) => item.id !== deleteId)
          );
          setDeleteId(null);
        }
      } catch (error) {
        toast.error(error.message);
        setDeleteId(null);
      }
    }
    setOpenDialog(false);
  };
  const handleAddClick = () => {
    setOpenAdd(true);
  };
  return (
    <div className={styles.section}>
      <DeleteDialog
        handleCloseDialog={handleCloseDialog}
        open={openDialog}
        message={"هل أنت متأكد من أنك تريد حذف هذه الطريقة للدفع؟"}
        handleDelete={handleDelete}
      />
      <NewPaymentMethod
        open={openAdd}
        triggerFetch={fetchData}
        closeDialog={handleCloseNewForm}
      />
      <EditPaymentMethod
        open={openEdit}
        triggerFetch={fetchData}
        closeDialog={handleCloseEditForm}
        row={selectedRow}
      />
      <div className={styles.sectionHeading}>
        <div className="text">
          <Typography
            variant="h6"
            fontWeight={600}
            color={theme.palette.neutral[800]}
          >
            طرق الدفع
          </Typography>
          <Typography variant="body2" color={theme.palette.neutral[600]}>
            قم بإدارة طرق دفع شركتك.
          </Typography>
        </div>
        <Button
          variant="contained"
          sx={{
            backgroundColor: theme.palette.primary[50],
            color: theme.palette.primary[600],
            border: `${theme.palette.primary[600]} 1px solid`,
          }}
          disableElevation={true}
          onClick={handleAddClick}
        >
          إضافة طريقة دفع جديدة
        </Button>
      </div>
      <div className={styles.table}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table
            stickyHeader
            aria-label="viewtypes table"
            sx={{ height: "100%" }}
          >
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.id === "actions" ? (
                              // Render action buttons for the "actions" column
                              <Box
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  alignItems: "center",
                                }}
                              >
                                {/* Edit Button */}
                                {role === "SuperAdmin" && (
                                  <Button
                                    variant="contained"
                                    sx={{
                                      width: "36px",
                                      height: "36px",
                                      padding: 0,
                                      margin: 0,
                                      minWidth: "auto",
                                      backgroundColor:
                                        theme.palette.neutral[50],
                                      "&:hover": {
                                        backgroundColor:
                                          theme.palette.neutral[100],
                                      },
                                    }}
                                    onClick={() => handleEditClick(row)}
                                    disableElevation
                                  >
                                    <PencilSquare
                                      size={16}
                                      color={theme.palette.primary[600]}
                                    />
                                  </Button>
                                )}

                                {/* Delete Button */}
                                {role === "SuperAdmin" && (
                                  <Button
                                    variant="contained"
                                    sx={{
                                      width: "36px",
                                      height: "36px",
                                      padding: 0,
                                      margin: 0,
                                      marginLeft: "8px",
                                      minWidth: "auto",
                                      backgroundColor:
                                        theme.palette.neutral[50],
                                      "&:hover": {
                                        backgroundColor:
                                          theme.palette.neutral[100],
                                      },
                                    }}
                                    onClick={() => handleDeleteClick(row.id)}
                                    disableElevation
                                  >
                                    <TrashFill
                                      size={16}
                                      color={theme.palette.primary[600]}
                                    />
                                  </Button>
                                )}
                              </Box>
                            ) : column.id === "allowDiscount" ? (
                              <Box>
                                <Switch
                                  key={`d-${row.id}`}
                                  checked={row.allowDiscount}
                                  onChange={() => handleAllowDiscount(row)}
                                />
                              </Box>
                            ) : column.id === "showAmount" ? (
                              <Box>
                                <Switch
                                  key={`a-${row.id}`}
                                  checked={row.showAmount}
                                  onChange={() => handleShowAmount(row)}
                                />
                              </Box>
                            ) : (
                              value // Default rendering for other columns
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={
            arEG.components.MuiTablePagination.defaultProps.labelRowsPerPage
          }
          labelDisplayedRows={
            arEG.components.MuiTablePagination.defaultProps.labelDisplayedRows
          }
        />
      </div>
    </div>
  );
}

export default PaymentMethodTable;
